import { createClient } from '@prismicio/client';
import { layoutAdapter } from './PrismicAdapter';

const PrismicServive = () => {
    const client = createClient(process.env.PRISMIC_API_REPO, {
        accessToken: process.env.PRISMIC_API_KEY,
    });
    const getLayout = async locale => {
        const prismicDoc = await client.getSingle('layout', { lang: locale });
        return layoutAdapter(prismicDoc);
    };

    return {
        getLayout,
    };
};

export default PrismicServive;
